import React from "react";

// Cabeçalho das páginas internas de uma marca (logo, nome, URL e metadados).
export const BrandHeader = ({ logo, name, active, siteUrl, companyName, customersCount, onCustomersClick }) => {
    return (
        <div className="brand-header-card">
            <div className="brand-header-logo">
                {logo
                    ? <img src={logo} alt={name} />
                    : <img src={require(`../../assets/images/svgs/default.svg`).default} alt={name} />
                }
            </div>
            <div className="brand-header-info">
                <div className="brand-header-title">
                    <h1>{name || 'Marca'}</h1>
                    {active !== undefined &&
                        <span className={`brand-header-status ${active ? 'on' : 'off'}`}>{active ? 'Ativa' : 'Inativa'}</span>
                    }
                </div>
                {siteUrl &&
                    <a href={siteUrl} target="_blank" rel="noopener noreferrer">
                        {siteUrl.replace(/^https?:\/\//, '')}
                        <img src={require(`../../assets/images/svgs/link.svg`).default} alt="" />
                    </a>
                }
            </div>
            <div className="brand-header-meta">
                <span className="label">Empresa vinculada</span>
                <span className="value">{companyName ?? '-'}</span>
            </div>
            <div className="brand-header-meta">
                <span className="label">Pessoas</span>
                {onCustomersClick
                    ? <button type="button" className="value" onClick={onCustomersClick}>{customersCount ?? 0}</button>
                    : <span className="value">{customersCount ?? 0}</span>
                }
            </div>
        </div>
    );
};

export default BrandHeader;
